'use strict';

window.jQuery = require('jquery');

var angular = require('angular');
require('angular-ui-router');
require('angular-animate');
require('angular-ui-bootstrap');
require('angular-translate');
require('angular-translate-loader-static-files');
require('angular-translate-storage-local');
require('angular-cookies');
require('angular-translate-storage-cookie');
require('angulartics');
require('angular-sanitize');
require('angular-inview');

// For local debugging use absolute path of bootstrap.js. For example 'C:\\Users\\username\\Desktop\\miramar-merged-landing-page\\msf_site_pkg\\miramar\\msf_site\\tornado\\web\\scripts\\bootstrap.js';
//require('C:\\Users\\akumar42\\Desktop\\IOS_silent\\miramar-merged-landing-page\\msf_site_pkg\\miramar\\msf_site\\tornado\\web\\scripts\\bootstrap.js');
require('/opt/buildAgent/work/SafeFamilyLandingPageMergedCode/msf_site_pkg/miramar/msf_site/tornado/web/scripts/bootstrap.js');




var app = angular.module('app', [ 
	'ui.router',
    'ngAnimate',
	'pascalprecht.translate',
    'ngCookies',
	'ui.bootstrap', 
	'angulartics', 
	'ngSanitize',
    'angular-inview'
]);

require('./constants');
require('./config');
require('./filters');
require('./directives');
require('./services');
require('./controllers');

// only when modernizr v3 is released
//require('modernizr/test/objectfit');
// var Modernizr = require('modernizr');

// Modernizr.load({
// 	test: Modernizr.objectfit,
// 	nope: [ ]
// });